
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/faq",
      function () {
        return require("private-next-pages/article/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/faq"])
      });
    }
  